export const elementToText = (element?: any) => {
  if (!element) {
    return "";
  }
  // Clone to avoid modifying original DOM
  const clone = element.cloneNode(true) as HTMLElement;

  // Replace all <br> with '\n' text nodes
  clone.querySelectorAll("br").forEach((br) => {
    const newline = document.createTextNode("\n");
    if (br) {
      br.parentNode?.replaceChildren(newline, br);
    }
  });

  return clone.textContent;
};
